(() => {
  if (window.acpGiveawayAnalyticsInitialized) return;

  const contextElement = document.querySelector('[data-acp-giveaway-context]');
  if (!contextElement) return;

  window.acpGiveawayAnalyticsInitialized = true;

  const GLOBAL_EVENT_NAME = 'acp_giveaway_event';
  const DEFAULT_CAMPAIGN_ID = '99559-b8nmiotq';
  const EVENTABEE_EVENT_NAME_MAP = {
    giveaway_view_item: 'product_view',
    giveaway_entry_package_add_success: 'add_to_cart',
    giveaway_cart_checkout_click: 'begin_checkout',
  };
  let giveawayContext = {};
  try {
    giveawayContext = JSON.parse(contextElement.textContent || '{}') || {};
  } catch (error) {
    giveawayContext = {};
  }

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, 160);

  const safeUrlParts = (value) => {
    if (!value) return {};
    try {
      const url = new URL(value, window.location.href);
      return {
        url: `${url.origin}${url.pathname}`,
        hostname: url.hostname,
        pathname: url.pathname,
      };
    } catch (error) {
      return {};
    }
  };

  const eventId = () => `acp-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const hasEmailValue = (root) => {
    if (!root || typeof root.querySelectorAll !== 'function') return false;
    return Array.from(root.querySelectorAll('input[type="email"], input[name*="email" i], input[id*="email" i]')).some((input) =>
      Boolean(String(input.value || '').trim())
    );
  };

  const elementContext = (element, extra = {}) => {
    const target = element && element.nodeType === 1 ? element : null;
    const inputLabel = target && ['button', 'submit', 'reset'].includes(String(target.type || '').toLowerCase()) ? target.value : '';
    const labelSource = target?.getAttribute('aria-label') || target?.getAttribute('data-acp-track-label') || target?.textContent || inputLabel || '';
    const urlData = safeUrlParts(target?.href || target?.action || target?.getAttribute('data-url'));
    const campaignId = target?.closest('[data-acp-campaign-id]')?.getAttribute('data-acp-campaign-id') || extra.campaign_id || DEFAULT_CAMPAIGN_ID;

    return {
      campaign_id: campaignId,
      action_label: cleanText(labelSource),
      element_tag: target ? target.tagName.toLowerCase() : undefined,
      interaction_type: extra.interaction_type,
      has_email: extra.has_email ?? hasEmailValue(target?.closest('form') || target?.closest('[data-acp-sweepwidget-modal]')),
      ...urlData,
      ...extra,
    };
  };

  const normalizePayload = (eventName, payload = {}) => {
    const normalized = {
      event: GLOBAL_EVENT_NAME,
      event_name: eventName || GLOBAL_EVENT_NAME,
      event_id: payload.event_id || eventId(),
      source: 'auto_city_promotions_giveaway',
      page_url: window.location.href,
      page_hostname: window.location.hostname,
      campaign_id: payload.campaign_id || DEFAULT_CAMPAIGN_ID,
      ...giveawayContext,
      ...payload,
    };

    Object.keys(normalized).forEach((key) => {
      if (normalized[key] === undefined || normalized[key] === null || normalized[key] === '') delete normalized[key];
    });

    return normalized;
  };

  const eventabeePayload = (data) => {
    const acpEventName = data.event_name;
    const eventabeeEventName = EVENTABEE_EVENT_NAME_MAP[acpEventName] || acpEventName;
    const payload = {
      ...data,
      event_name: eventabeeEventName,
      acp_event_name: acpEventName,
    };

    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === null || payload[key] === '') delete payload[key];
    });

    return payload;
  };

  const track = (eventName, payload = {}) => {
    const data = normalizePayload(eventName, payload);
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    } catch (error) {}

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('eb_custom', eventabeePayload(data));
      }
    } catch (error) {}

    try {
      window.dispatchEvent(new CustomEvent('acp:giveaway:track', { detail: data }));
    } catch (error) {}
    return data;
  };

  window.acpGiveawayTrack = track;
  window.autoCityPromoTrack = track;
  window.acpGiveawayElementContext = elementContext;

  track('giveaway_view_item', { interaction_type: 'page_view' });

  document.addEventListener('click', (event) => {
    const tracked = event.target.closest('[data-acp-track], .giveaway-cta-buttons .giveaway-button, .giveaway-sticky-cta .giveaway-button');
    if (!tracked) return;
    const eventName = tracked.getAttribute('data-acp-track-event') || 'giveaway_cta_click';
    track(eventName, elementContext(tracked, { interaction_type: 'click' }));
  });
})();
